import { render, staticRenderFns } from "./TenderDocuments.vue?vue&type=template&id=f40634e2"
import script from "./TenderDocuments.vue?vue&type=script&lang=js"
export * from "./TenderDocuments.vue?vue&type=script&lang=js"
import style0 from "./TenderDocuments.vue?vue&type=style&index=0&id=f40634e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports